/**
 * Author：brand
 * Creation Time：2019-05-11 10:37
 * Email：brandhuang@qq.com
 */
import axios from 'axios'

var service = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  timeout: 10000,
  withCredentials: true
  // headers: {"Content-Type": "application/x-www-form-urlencoded"},
})
/**
 * 请求拦截器
 */
service.interceptors.request.use(
  config => {
    return config
  }, error => {
    return Promise.reject(error)
  }
)

/**
 * 响应拦截器
 */
service.interceptors.response.use(
  response => {
    let res = response.data
    return res
  },
  err => {
    if (err && err.response) {
    } else {
      err.message = '网络连接异常，请稍后重试！'
    }
    return Promise.reject(err)
  }
)

export default service
